import {
    ArrowDownward as ArrowDownwardIcon,
    ArrowUpward as ArrowUpwardIcon,
    Remove as RemoveIcon,
} from '@mui/icons-material';
import { Skeleton, Typography } from '@mui/material';
import Row from '../../../../components/Row';
import theme from '../../../../theme';
import { useMemo } from 'react';

export function HatChangeMetricWithSkeleton(props: {
    value: number | null | undefined;
    format?: (value: number | null | undefined) => string;
    skeleton?: number;
    changeCode?: 'up' | 'down' | 'center';
    biggerIsBetter?: boolean;
}) {
    const { value, format, skeleton, changeCode, biggerIsBetter } = props;

    const hasValue = value !== null && value !== undefined;
    const iconUpColor = biggerIsBetter ?? true ? 'success' : 'error';
    const iconDownColor = biggerIsBetter ?? true ? 'error' : 'success';
    const valueColor = {
        up: biggerIsBetter ?? true ? theme.palette.success.main : theme.palette.error.main,
        down: biggerIsBetter ?? true ? theme.palette.error.main : theme.palette.success.main,
        center: 'action',
    }[changeCode ?? 'center'];

    const formattedValue = useMemo(() => {
        return format ? format(value) : String(value);
    }, [value, format]);

    if (hasValue) {
        return (
            <Row gap={0.5} width="auto">
                {changeCode === 'up' && <ArrowUpwardIcon color={iconUpColor} fontSize="small" />}
                {changeCode === 'down' && <ArrowDownwardIcon color={iconDownColor} fontSize="small" />}
                {changeCode === 'center' && <RemoveIcon color="action" fontSize="small" />}

                <Typography variant="inherit" color={valueColor}>
                    {formattedValue}
                </Typography>
            </Row>
        );
    } else if ((skeleton ?? 0) > 0) {
        return <Skeleton width={skeleton} />;
    } else {
        return <></>;
    }
}
